import React, { useState, useEffect } from "react";
import logo from "./assets/logo.png";
import wlogo from "./assets/wlogo.png";
import smhLogo from "./assets/smhlogo.png";
import smhApp from "./assets/appsmh.png";
import sfudoApp from "./assets/sfudoapp.png";
import resrchimg from "./assets/reserch-img.jpeg";
import sfudoLogo from "./assets/sfudologo.png";
import rudraLogo from "./assets/rwslogo.png";
import atharv from "./assets/atharv.png";
import om from "./assets/om.png";
import { FiMail, FiMenu, FiX, FiPhone, FiChevronDown } from "react-icons/fi";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

import loadingImg from "./assets/load.png";
const App = () => {
      const newsItems = [
         {
      date: "20 May 2025",
      title: "First Draft of SFUdo Completed",
      description:
        "The first draft of SFUdo has been completed, and we are now in the testing phase with real-world live lectures running on SMH Tech.",
    },
    {
      date: "1 Apr 2026",
      title: "SMH Tech iOS Development Started",
      description:
        "SMH Tech iOS development has officially started. If you are interested in development or collaboration, get in touch with us.",
    },
    {
      date: "10 Jan 2026",
      title: "SMH Tech Launch",
      description:
        "SMH Tech is now officially released as an e-learning platform in partnership with Prof. Sanghpal M. Humane. The app is available on the Play Store, and users can download it now. We also have future plans to release it on iOS.",
    },
   
  ]
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  const [mobileCompanyOpen, setMobileCompanyOpen] = useState(false);
  const [desktopProductsOpen, setDesktopProductsOpen] = useState(false);
const [desktopCompanyOpen, setDesktopCompanyOpen] = useState(false);

  const products = [
    {
      name: "SMH Tech",
      type: "smhtech",
      logo: smhLogo,
    },
    {
      name: "SFUdo",
      type: "sfudo",
      logo: sfudoLogo,
    },
  ];

  const getPageFromPath = () => {
    if (window.location.pathname === "/about/") return "about";
    if (window.location.pathname === "/research/") return "research";
    if (window.location.pathname === "/smhtech/") return "smhtech";
    if (window.location.pathname === "/sfudo/") return "sfudo";
    if (window.location.pathname === "/news/") return "news";
     if (window.location.pathname === "/opportunities/") return "oppor";

     return "home";
    
    
  };

  const [currentPage, setCurrentPage] = useState(getPageFromPath);

  const isHomePage = currentPage === "home";
  const isAboutPage = currentPage === "about";
  const isResearchPage = currentPage === "research";
  const isSMHPage = currentPage === "smhtech";
  const isSFudoPage = currentPage === "sfudo";
  const isNewsPage = currentPage === "news";
  const isOpporPage = currentPage === "oppor";
  
  const closeMenus = () => {
    setMobileMenuOpen(false);
    setMobileCompanyOpen(false);
    setMobileProductsOpen(false);
  };

  const goToPage = (page, url) => {
    setCurrentPage(page);
    window.history.pushState({}, "", url);
    closeMenus();

 window.scrollTo({
  top: 0,
  behavior: "auto",
});
  };

 const goToHomePage = () => {
  goToPage("home", "/");
};

const goToAboutPage = () => {
  goToPage("about", "/about/");
};

const goToResearchPage = () => {
  goToPage("research", "/research/");
};
const goToSMHtechPage = () => {
  goToPage("smhtech", "/smhtech/");
};

const goToSFUdoPage = () => {
  goToPage("sfudo", "/sfudo/");
};
const goNewsPage = () => {
  goToPage("news", "/news/");
};
const goToOpporPage = () => {
  goToPage("oppor", "/opportunities/");
};


  const [activeSection, setActiveSection] = useState("intro");
  const [navbarScrolled, setNavbarScrolled] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isLoading, setIsLoading] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  // Loading simulation
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  // Handle mouse movement
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
      setActiveSection(id);
      setMobileMenuOpen(false);
    }
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };
  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
    message: "",
  });

  const [toast, setToast] = React.useState({
    show: false,
    type: "success", // "error"
    message: "",
  });

  const showToast = (type, message) => {
    setToast({ show: true, type, message });

    setTimeout(() => {
      setToast({ show: false, type: "", message: "" });
    }, 8000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      showToast("error", "Please fill in all fields before submitting.");
      return;
    }

    // Start loading
    setIsSubmitting(true);

    // Simulate API / email delay (2.5 seconds)
    setTimeout(() => {
      setIsSubmitting(false);

      showToast(
        "success",
        "Thank you for contacting us. We will contact you soon. If you do not receive a response, please email us at info@bashdot.com.",
      );

      // Reset form
      setFormData({
        name: "",
        email: "",
        message: "",
      });
    }, 2500);
  };

  // Loading Screen Component
  if (isLoading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-[#dfe9ee] z-50">
        <div className="text-center">
          {/* ROTATING LOADING IMAGE */}
          <img
            src={loadingImg}
            alt="Loading"
            className="w-24 h-24 mx-auto mb-0 animate-spin-slow"
          />

          <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-black bg-clip-text text-transparent">
            BASHDOT
          </h2>
          <p className="text-gray-500 mt-2">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    // <div className="min-h-screen  bg-[#dfe9ee] text-gray-900 overflow-hidden">
    <div
      className={`min-h-screen text-gray-900 overflow-hidden ${
        !isHomePage ? "bg-white" : "bg-[#dfe9ee]"
      }`}
    >
      
      {/* Animated gradient orbs with glass effect - Fixed alignment for mobile */}
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          !isHomePage
            ? navbarScrolled
              ? "bg-white shadow-sm border-b border-gray-200/60"
              : "bg-white"
            : navbarScrolled
              ? "bg-[#dfe9ee] shadow-sm border-b border-gray-200/60"
              : "bg-[#dfe9ee]"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-3 py-3 flex items-center justify-between">
          <motion.img
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            src={logo}
            alt="BashDot Logo"
            onClick={goToHomePage}
            className="h-9 w-auto cursor-pointer object-contain"
          />

          {/* ================= DESKTOP MENU ================= */}
          <ul className="hidden md:flex ml-auto space-x-6">
            {["Research", "Products", "Company", "News"].map((item) => (
            <li
                key={item}
                className="relative"
                onMouseEnter={() => {
                    if (item === "Products") setDesktopProductsOpen(true);
                    if (item === "Company") setDesktopCompanyOpen(true);
                }}
                onMouseLeave={() => {
                    if (item === "Products") setDesktopProductsOpen(false);
                    if (item === "Company") setDesktopCompanyOpen(false);
                }}
                >
                <motion.button
                  whileHover={{ y: -2 }}
                  whileTap={{ y: 0 }}
                  onClick={() =>{
                    if(item==="News"){
                        goNewsPage();
                    }
                    if(item==="Research"){
                        goToResearchPage();
                    }
                     if (item === "Products") {
                        setDesktopProductsOpen((prev) => !prev);
                        setDesktopCompanyOpen(false);
                    }

                    if (item === "Company") {
                        setDesktopCompanyOpen((prev) => !prev);
                        setDesktopProductsOpen(false);
                    }
                }
                  }
                  className={`group relative px-3 py-1.5 text-[16px] transition-all duration-300 ${
                    activeSection === item
                      ? "text-[#0f0f0e]"
                      : "text-[#0f0f0e] hover:text-gray-900"
                  }`}
                >
                  <span className="flex items-center gap-1">
                    {item}

                    {(item === "Products" || item === "Company") && (
                      <FiChevronDown className="text-sm transition-transform duration-300 group-hover:rotate-180" />
                    )}

                  </span>

                  <span
                    className={`absolute bottom-0 left-0 h-0.5 w-full origin-left bg-gray-900 transform transition-all duration-300 ${
                      activeSection === item
                        ? "scale-x-100 opacity-100"
                        : "scale-x-0 opacity-0 group-hover:scale-x-100 group-hover:opacity-100"
                    }`}
                  />
                </motion.button>

                {/* Products Dropdown */}
                {item === "Products" && desktopProductsOpen && (
                 <div className="absolute left-0 top-full z-50 pt-3">
                 <div className="w-60 rounded-xl bg-[#faf9f5]/95 backdrop-blur-xl shadow-xl border border-gray-200/60 transition-all duration-300 overflow-hidden">
                    <div className="px-5 pt-4 pb-2">
                      <p className="text-xs uppercase tracking-[0.18em] text-gray-500">
                        Explore Products
                      </p>
                    </div>

                    {products.map((product, index) => (
                      <button
                        key={product.name}
                        onClick={() => {
                            if(product.type==="smhtech"){
                                goToSMHtechPage()
                            }
                            if(product.type==="sfudo"){
                                goToSFUdoPage()
                            }
                            setDesktopProductsOpen(false);
                        }}
                        className={`group/product flex w-full items-center gap-3 px-4 py-2.5 text-left text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-100/80 transition-all duration-200 ${
                          index === products.length - 1 ? "rounded-b-xl" : ""
                        }`}
                        
                      >
                        <img
                          src={product.logo}
                          alt={product.name}
                          className="h-7 w-7 rounded-md object-contain"
                        />

                        <span className="text-[#0f0f0e]">{product.name}</span>
                      </button>
                    ))}
                  </div>
                  </div>
                )}

                {/* Company Dropdown */}
                {item === "Company" && desktopCompanyOpen&& (
                 <div className="absolute left-0 top-full z-50 pt-3">
                   <div className="w-60 rounded-xl bg-[#faf9f5]/95 backdrop-blur-xl shadow-xl border border-gray-200/60 transition-all duration-300 overflow-hidden">
                    <div className="px-5 pt-4 pb-2">
                      <p className="text-xs uppercase tracking-[0.18em] text-gray-500">
                        Explore Us
                      </p>
                    </div>

                    {[
                      { name: "About Us", section: "about-us", type: "about" },
                      { name: "Opportunities", section: "careers", type: "oppor" },
                    ].map((companyItem, index, arr) => (
                      <button
                        key={companyItem.name}
                        onClick={() => {
                          if (companyItem.type === "about") {
                            goToAboutPage();
                             setDesktopCompanyOpen(false)
                          }
                          if (companyItem.type === "oppor") {
                            goToOpporPage();
                             setDesktopCompanyOpen(false)
                          }  
                          
                        }}
                        className={`group/company flex w-full items-center gap-2 px-5 py-2.5 text-left text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-100/80 transition-all duration-200 ${
                          index === arr.length - 1 ? "rounded-b-xl" : ""
                        }`}
                      >
                        <span className="text-[#0f0f0e]">
                          {companyItem.name}
                        </span>
                      </button>
                    ))}
                  </div>
                  </div>
                )}
              </li>
            ))}
          </ul>

          {/* ================= MOBILE MENU BUTTON ================= */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-gray-700 z-50"
          >
            {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>

          {/* ================= DESKTOP CONTACT BUTTON ================= */}
          <motion.button
            whileHover={{
              scale: 1.05,
              boxShadow: "0 8px 20px -5px rgba(0, 0, 0, 0.1)",
            }}
            whileTap={{ scale: 0.95 }}
            onClick={() => scrollToSection("contact")}
            className="hidden md:block ml-8 px-5 py-2 min-w-[130px] text-white bg-gradient-to-r from-gray-900 via-gray-800 to-black rounded-lg hover:from-gray-800 hover:via-gray-700 hover:to-black transition-all duration-300 shadow-lg"
          >
            Get in Touch
          </motion.button>
        </div>

        {/* ================= MOBILE MENU ================= */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <>
              {/* Backdrop */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setMobileMenuOpen(false)}
                className="fixed inset-0 bg-black/20 z-[9998]"
              />

              {/* Mobile Panel */}
              <motion.div
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -20, opacity: 0 }}
                transition={{ duration: 0.25 }}
                className="md:hidden fixed inset-x-0 top-[60px] bg-[#faf9f5]/95 backdrop-blur-xl border-t border-gray-200/20 z-[9999] shadow-xl"
              >
                <div className="max-w-7xl mx-auto px-4 py-4">
                  <div className="flex flex-col space-y-2">
                    {/* Research */}
                    <motion.button
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -10 }}
                      transition={{ delay: 0.05 }}
                      onClick={() => {
                        goToResearchPage()
                      }}
                      className={`text-left px-4 py-3 rounded-lg transition-all duration-200 ${
                        activeSection === "Research"
                          ? "bg-gray-100 text-gray-900"
                          : "text-[#0f0f0e] hover:bg-gray-50"
                      }`}
                    >
                      Research
                    </motion.button>

                    {/* Products Mobile Dropdown */}
                    <div className="rounded-lg overflow-hidden">
                      <button
                        onClick={() =>
                          setMobileProductsOpen(!mobileProductsOpen)
                        }
                        className="w-full flex items-center justify-between px-4 py-3 rounded-lg text-left text-[#0f0f0e] hover:bg-gray-50 transition-all duration-200"
                      >
                        <span>Products</span>
                        <FiChevronDown
                          className={`text-sm transition-transform duration-300 ${
                            mobileProductsOpen ? "rotate-180" : ""
                          }`}
                        />
                      </button>

                      <AnimatePresence>
                        {mobileProductsOpen && (
                          <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.2 }}
                            className="overflow-hidden"
                          >
                            <div className="mx-4 mb-2 rounded-xl bg-white/60 border border-gray-200/50 overflow-hidden">
                              <div className="px-4 pt-3 pb-2">
                                <p className="text-xs uppercase tracking-[0.18em] text-gray-500">
                                  Explore Products
                                </p>
                              </div>

                              {products.map((product, index) => (
                                <button
                                  key={product.name}
                                  onClick={() => {
                                      if(product.type==="smhtech"){
                                            goToSMHtechPage()
                                        }
                                        if(product.type==="sfudo"){
                                            goToSFUdoPage()
                                        }
                                  }}
                                  className={`flex w-full items-center gap-3 px-4 py-2.5 text-left text-sm hover:bg-gray-100/80 transition-all duration-200 ${
                                    index === products.length - 1
                                      ? "rounded-b-xl"
                                      : ""
                                  }`}
                                >
                                  <img
                                    src={product.logo}
                                    alt={product.name}
                                    className="h-7 w-7 rounded-md object-contain"
                                  />

                                  <span className="text-[#0f0f0e]">
                                    {product.name}
                                  </span>
                                </button>
                              ))}
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>

                    {/* Company Mobile Dropdown */}
                    <div className="rounded-lg overflow-hidden">
                      <button
                        onClick={() => setMobileCompanyOpen(!mobileCompanyOpen)}
                        className="w-full flex items-center justify-between px-4 py-3 rounded-lg text-left text-[#0f0f0e] hover:bg-gray-50 transition-all duration-200"
                      >
                        <span>Company</span>
                        <FiChevronDown
                          className={`text-sm transition-transform duration-300 ${
                            mobileCompanyOpen ? "rotate-180" : ""
                          }`}
                        />
                      </button>

                      <AnimatePresence>
                        {mobileCompanyOpen && (
                          <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.2 }}
                            className="overflow-hidden"
                          >
                            <div className="mx-4 mb-2 rounded-xl bg-white/60 border border-gray-200/50 overflow-hidden">
                              <div className="px-4 pt-3 pb-2">
                                <p className="text-xs uppercase tracking-[0.18em] text-gray-500">
                                  Explore Us
                                </p>
                              </div>

                              {[
                                {
                                  name: "About Us",
                                  section: "about-us",
                                  type: "about",
                                },
                                {
                                  name: "Opportunities",
                                  section: "careers",
                                  type: "oppor",
                                },
                              ].map((companyItem, index, arr) => (
                                <button
                                  key={companyItem.name}
                                  onClick={() => {
                                    if (companyItem.type === "about") {
                                      goToAboutPage();
                                    } 
                                     if (companyItem.type === "oppor") {
                                      goToOpporPage();
                                    } 
                                  }}
                                  className={`flex w-full items-center px-4 py-2.5 text-left text-sm hover:bg-gray-100/80 transition-all duration-200 ${
                                    index === arr.length - 1
                                      ? "rounded-b-xl"
                                      : ""
                                  }`}
                                >
                                  <span className="text-[#0f0f0e]">
                                    {companyItem.name}
                                  </span>
                                </button>
                              ))}
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>

                    {/* News */}
                    <motion.button
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -10 }}
                      transition={{ delay: 0.1 }}
                      onClick={() => {
                         
                                goNewsPage();
                            
                      }}
                      className={`text-left px-4 py-3 rounded-lg transition-all duration-200 ${
                        activeSection === "News"
                          ? "bg-gray-100 text-gray-900"
                          : "text-[#0f0f0e] hover:bg-gray-50"
                      }`}
                    >
                      News
                    </motion.button>

                    {/* Mobile Contact Button */}
                    <button
                      onClick={() => {
                        scrollToSection("contact");
                        setMobileMenuOpen(false);
                      }}
                      className="mt-2 w-full px-5 py-3 text-white bg-gradient-to-r from-gray-900 via-gray-800 to-black rounded-lg shadow-lg"
                    >
                      Get in Touch
                    </button>
                  </div>
                </div>
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </motion.nav>

      {isHomePage && (
        <section id="onboardingsection">
          {/* indutrouction  */}
          <section
            id="intro"
            className="min-h-[90vh] flex items-center justify-center pt-20 md:pt-16 relative"
          >
            <motion.div
              initial="hidden"
              animate="visible"
              variants={fadeInUp}
              className="text-center max-w-4xl px-4 sm:px-6 relative z-10"
            >
              <motion.div variants={fadeInUp} className="mb-6">
                <span className="text-sm  text-gray-500 uppercase tracking-wider">
                  Innovative Technology Solutions
                </span>
              </motion.div>

              <motion.h1
                variants={fadeInUp}
                className="text-3xl sm:text-4xl md:text-6xl  mb-6 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent leading-tight"
              >
                Building the Future
                <br />
                <span className="bg-gradient-to-r from-black to-gray-700 bg-clip-text text-transparent">
                  with Technology
                </span>
              </motion.h1>

              <motion.p
                variants={fadeInUp}
                className="text-base md:text-lg text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed px-4"
              >
                We are a startup focused Building Real Time Products and AI
                Research on Real Time Data for This Era.
              </motion.p>

              {/* <motion.div
                                        variants={fadeInUp}
                                        className="flex flex-col sm:flex-row gap-3 justify-center px-4"
                                        >
                                        <motion.button
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.95 }}
                                            onClick={() => scrollToSection("services")}
                                            className="px-6 py-3 text-base font-semibold text-white bg-gradient-to-r from-gray-900 via-gray-800 to-black rounded-lg hover:from-gray-800 hover:via-gray-700 hover:to-black transition-all duration-300 shadow-xl relative overflow-hidden group"
                                        >
                                            <span className="relative z-10">Explore Our Services</span>
                                            <div className="absolute inset-0 bg-gradient-to-r from-black to-gray-800 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                                        </motion.button>
                            
                                        <motion.button
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.95 }}
                                            onClick={() => scrollToSection("contact")}
                                            className="px-6 py-3 text-base font-semibold text-gray-900 border border-gray-900 rounded-lg hover:bg-gradient-to-r hover:from-gray-900 hover:to-black hover:text-white transition-all duration-300 relative overflow-hidden group"
                                        >
                                            <span className="relative z-10">Get Started</span>
                                            <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-black transform scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300" />
                                        </motion.button>
                                        </motion.div> */}
            </motion.div>
          </section>

          <section id="projects" className=" pb-16 md:pt-12 md:pb-24 relative">
            <div className="absolute inset-0 bg-gradient-to-b  via-gray-50/20 to-white" />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
                className="text-center mb-16"
              >
                <span className="text-sm  text-gray-500 uppercase tracking-wider">
                  Our Work
                </span>
                <h2 className="text-3xl md:text-4xl  mt-3 mb-4 bg-gradient-to-r from-gray-900 via-gray-800 to-black bg-clip-text text-transparent">
                  Recent Release
                </h2>
                {/* <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed px-4">
                                    A flagship e-learning platform built to deliver seamless education
                                    experiences across web and mobile.
                                    </p> */}
              </motion.div>

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={staggerContainer}
                className="grid lg:grid-cols-2 gap-12 items-center"
              >
                <motion.div variants={fadeInUp} className="px-4 sm:px-0">
                  <motion.img
                    whileHover={{ scale: 1.05 }}
                    src={smhLogo}
                    alt="SMH Tech Logo"
                    className="h-12 mb-4"
                  />
                  <h3 className="text-2xl md:text-3xl  mb-3 text-gray-900">
                    SMH Tech
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    A complete digital learning ecosystem designed for students,
                    educators, and institutions. The platform supports video
                    lectures, secure authentication, payments, progress
                    tracking, live meeting sessions, and mobile-first learning
                    through Android applications.
                  </p>

                  {/* <div className="flex flex-wrap gap-2 mb-6">
                                        {[
                                        "E-Learning",
                                        "Android App",
                                        "Web Platform",
                                        "Cloud Backend",
                                        "Secure Streaming",
                                        ].map((tag) => (
                                        <span
                                            key={tag}
                                            className="px-3 py-1 text-xs font-medium bg-gradient-to-r from-gray-100/80 to-gray-50/80 backdrop-blur-sm text-gray-700 rounded-full border border-gray-200/50"
                                        >
                                            {tag}
                                        </span>
                                        ))}
                                    </div> */}
                  <div className="flex flex-col sm:flex-row items-center gap-3">
                    <motion.a
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      href="https://play.google.com/store/apps/details?id=com.vigyanixtech.smhtech&hl=en_IN"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-gray-900 to-black text-white rounded-lg hover:from-gray-800 hover:to-black transition-all duration-300 shadow-lg hover:shadow-xl"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className="w-5 h-5"
                        fill="currentColor"
                      >
                        <path d="M325.3 234.3L104.6 13.6c-5.5-5.5-13.6-6.9-20.4-3.6L267.5 256 84.2 502c6.8 3.3 14.9 1.9 20.4-3.6l220.7-220.7c7.6-7.6 7.6-19.8 0-27.4z" />
                      </svg>

                      <span className="text-sm font-semibold">
                        Download on Play Store
                      </span>
                    </motion.a>

                    {/* <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() => scrollToSection("smh-details")}
                      className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-semibold text-gray-900 border border-gray-900 rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300"
                    >
                      Read More
                    </motion.button> */}
                  </div>
                </motion.div>

                <motion.div
                  variants={fadeInUp}
                  whileHover={{ scale: 1.02 }}
                  className="flex justify-center"
                >
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-br from-gray-100/30 to-white/20 backdrop-blur-sm rounded-3xl blur-xl" />
                    <img
                      src={smhApp}
                      alt="SMH Tech Mobile Application"
                      className="relative w-[240px] sm:w-[280px] lg:w-[320px] h-auto object-contain drop-shadow-2xl"
                    />
                  </div>
                </motion.div>
              </motion.div>
            </div>
          </section>
        </section>
      )}

      {isAboutPage && (
        <section id="aboutsection" className="min-h-screen bg-white pt-24 px-4">
          <section
            id="intro"
            className="min-h-[40vh] flex  justify-center pt-10 md:pt-10 relative"
          >
            <motion.div
              initial="hidden"
              animate="visible"
              className="text-center max-w-4xl px-4 sm:px-6 relative z-10"
            >
              <motion.h1
                // variants={fadeInUp}
                className="text-3xl sm:text-4xl md:text-6xl  mb-6 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent leading-tight"
              >
                About
              </motion.h1>

              <motion.p
                variants={fadeInUp}
                className="text-base md:text-lg text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed px-4"
              >
                We deliver end-to-end software solutions across web, mobile,
                cloud, and emerging technologies to help startups and
                enterprises scale faster.
              </motion.p>
            </motion.div>
          </section>
          <section className=" pb-16 md:pt-5 md:pb-24 relative">
            <div className="absolute inset-0 bg-gradient-to-b from-white via-gray-50/10 to-white" />
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
                className="text-center"
              >
                <span className="text-sm  text-gray-500 uppercase tracking-wider">
                  Our Purpose
                </span>
                <h2 className="text-3xl md:text-4xl  mt-3 mb-8 bg-gradient-to-r from-gray-900 via-gray-800 to-black bg-clip-text text-transparent">
                  Vision & Mission
                </h2>

                <div className="bg-white/80 backdrop-blur-sm border border-gray-200/30 rounded-2xl p-6 md:p-8 shadow-xl relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-48 h-48 bg-gradient-to-bl from-gray-100/20 to-transparent rounded-full -translate-y-24 translate-x-24" />
                  <div className="absolute bottom-0 left-0 w-48 h-48 bg-gradient-to-tr from-gray-100/20 to-transparent rounded-full translate-y-24 -translate-x-24" />

                  <motion.div
                    variants={fadeInUp}
                    className="relative z-10 mb-8"
                  >
                    <h3 className="text-xl  mb-3 text-gray-900">Our Vision</h3>
                    <p className="text-lg md:text-xl text-gray-700 leading-relaxed ">
                      To build large scale real time media systems and AI
                      products that understand images, video, and audio,
                      transforming media into meaningful insights and
                      intelligent experiences.
                    </p>
                  </motion.div>

                  <motion.div
                    variants={fadeInUp}
                    className="w-20 h-1 bg-gradient-to-r from-gray-900 via-gray-700 to-black mx-auto rounded-full mb-8"
                  />

                  <motion.div variants={fadeInUp} className="relative z-10">
                    <h3 className="text-xl  mb-3 text-gray-900">Our Mission</h3>
                    <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                      Our mission is to build large-scale real-time
                      communication and media systems powered by AI. We develop
                      intelligent technologies that understand images, video,
                      and audio in real time — transforming complex media data
                      into meaningful insights, automation, and interactive
                      experiences for real-world applications.
                    </p>
                  </motion.div>
                </div>
              </motion.div>
            </div>
          </section>
          <section id="partners" className=" pb-16 md:pt-12 md:pb-24 relative">
            <div className="absolute inset-0 bg-gradient-to-b from-white via-gray-50/10 to-white" />
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
                className="text-center mb-12"
              >
                <span className="text-sm  text-gray-500 uppercase tracking-wider">
                  Collaborations
                </span>
                <h2 className="text-3xl md:text-4xl mt-3 mb-4 bg-gradient-to-r from-gray-900 via-gray-800 to-black bg-clip-text text-transparent">
                  Our Partners
                </h2>
                <p className="text-gray-600 max-w-xl mx-auto leading-relaxed">
                  Collaborating with trusted organizations to build impactful
                  technology solutions
                </p>
              </motion.div>

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={staggerContainer}
                className="flex justify-center"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-md">
                  <motion.a
                    variants={fadeInUp}
                    whileHover={{ y: -4 }}
                    href="https://smhtechacademy.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white/80 backdrop-blur-sm border border-gray-200/50 rounded-xl p-6 flex flex-col items-center justify-center hover:border-gray-300/50 hover:shadow-lg transition-all duration-400 group"
                  >
                    <div className="relative">
                      <div className="absolute inset-0 bg-gradient-to-br from-gray-100/20 to-white/10 rounded-full blur opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
                      <img
                        src={smhLogo}
                        alt="SMH Tech Academy"
                        className="h-12 object-contain mb-3 relative z-10"
                      />
                    </div>
                    <span className="text-sm  text-gray-700 text-center">
                      SMH Tech Academy
                    </span>
                  </motion.a>

                  <motion.a
                    variants={fadeInUp}
                    whileHover={{ y: -4 }}
                    href="https://rudrawebsolutions.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white/80 backdrop-blur-sm border border-gray-200/50 rounded-xl p-6 flex flex-col items-center justify-center hover:border-gray-300/50 hover:shadow-lg transition-all duration-400 group"
                  >
                    <div className="relative">
                      <div className="absolute inset-0 bg-gradient-to-br from-gray-100/20 to-white/10 rounded-full blur opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
                      <img
                        src={rudraLogo}
                        alt="Rudra Web Solutions"
                        className="h-12 object-contain mb-3 relative z-10"
                      />
                    </div>
                    <span className="text-sm  text-gray-700 text-center">
                      Rudra Web Solutions
                    </span>
                  </motion.a>
                </div>
              </motion.div>
            </div>
          </section>
          <section id="team" className=" pb-16 md:pt-12 md:pb-24 relative">
            <div className="absolute inset-0 bg-gradient-to-b from-white via-gray-50/10 to-white" />
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
                className="text-center mb-12"
              >
                <span className="text-sm  text-gray-500 uppercase tracking-wider">
                  Who We Are
                </span>
                <h2 className="text-3xl md:text-4xl mt-3 mb-4 bg-gradient-to-r from-gray-900 via-gray-800 to-black bg-clip-text text-transparent">
                  Meet Our Founder's
                </h2>
                <p className="text-gray-600 max-w-xl mx-auto leading-relaxed">
                  Passionate professionals dedicated to innovation and
                  excellence
                </p>
              </motion.div>

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={staggerContainer}
                className="grid gap-6 text-center place-items-center grid-cols-1 sm:grid-cols-2 max-w-2xl mx-auto"
              >
                {[
                  {
                    name: "Atharv Wankhade",
                    role: "Founder & Developer",
                    title: "Developer",
                    image: atharv,
                    email: "atharv@bashdot.com",
                    linkedin:
                      "https://www.linkedin.com/in/atharv-wankhade-9b8157325/",
                    whatsapp: "https://wa.me/919579695567",
                  },
                  {
                    name: "Om Wanave",
                    role: "Founder & Developer",
                    title: "Developer",
                    image: om,
                    email: "om@bashdot.com",
                    linkedin:
                      "https://www.linkedin.com/in/om-wanave-235330378/",
                    whatsapp: "https://wa.me/919067788378",
                  },
                ].map((member, index) => (
                  <motion.div
                    key={index}
                    variants={fadeInUp}
                    whileHover={{ y: -6 }}
                    className="group bg-white/80 backdrop-blur-sm border border-gray-200/50 rounded-xl p-6 hover:border-gray-300/50 hover:shadow-lg transition-all duration-400 relative overflow-hidden w-full max-w-xs"
                  >
                    <div className="absolute inset-0 bg-gradient-to-br from-gray-50/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
                    <div className="relative z-10">
                      <div className="w-24 h-24 mx-auto rounded-full bg-gradient-to-br from-gray-100/80 to-gray-50/80 overflow-hidden relative mb-4 group-hover:scale-105 transition-transform duration-400">
                        <img
                          src={member.image}
                          alt={member.name}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent" />
                      </div>
                      <h4 className="text-lg  text-gray-900 mb-1">
                        {member.name}
                      </h4>
                      <p className="text-gray-700  text-sm mb-0.5">
                        {/* {member.role} */}
                      </p>
                      {/* <p className="text-gray-500 text-sm">{member.title}</p> */}

                      <div className="mt-4 flex justify-center space-x-3">
                        <motion.a
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          href={`mailto:${member.email}`}
                          title="Email"
                          className="w-8 h-8 rounded-full bg-gradient-to-br from-gray-100/80 to-gray-50/80 border border-gray-200/50 flex items-center justify-center hover:from-gray-200/80 hover:to-gray-100/80 transition-all duration-300"
                        >
                          <FiMail className="text-gray-700 text-sm" />
                        </motion.a>
                        <motion.a
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          href={member.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          title="LinkedIn"
                          className="w-8 h-8 rounded-full bg-gradient-to-br from-gray-100/80 to-gray-50/80 border border-gray-200/50 flex items-center justify-center hover:from-gray-200/80 hover:to-gray-100/80 transition-all duration-300"
                        >
                          <FaLinkedinIn className="text-gray-700 text-sm" />
                        </motion.a>
                        <motion.a
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          href={member.whatsapp}
                          target="_blank"
                          rel="noopener noreferrer"
                          title="WhatsApp"
                          className="w-8 h-8 rounded-full bg-gradient-to-br from-gray-100/80 to-gray-50/80 border border-gray-200/50 flex items-center justify-center hover:from-gray-200/80 hover:to-gray-100/80 transition-all duration-300"
                        >
                          <FaWhatsapp className="text-gray-700 text-sm" />
                        </motion.a>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </motion.div>
            </div>
          </section>
        </section>
      )}

        {isResearchPage && (
        <section id="researchsection" className="min-h-screen bg-white pt-24 px-4">
         <section
            id="intro"
           className="min-h-[30vh] flex items-center pt-5 md:pt-5 relative bg-white mb-20 md:mb-0"
            >
            <motion.div
                initial="hidden"
                animate="visible"
                className="w-full max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10"
            >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-start">
                
                {/* Left Side Title */}
                <motion.div>
                    <motion.h1
                    className="text-[50px] sm:text-[50px] md:text-[50px] lg:text-[70px] font-normal leading-[0.95] tracking-[-0.04em] text-[#0f0f0e]"
                    >
                    Research
                    </motion.h1>
                </motion.div>

                {/* Right Side Paragraph */}
                <motion.div>
                    <motion.p
                    variants={fadeInUp}
                    className="text-[17px] md:text-[20px] leading-[1.55] text-[#391413] y-600 max-w-xl md:pt-3"
                    >
                    We are focused on four core research areas: real time communication and media systems, AI powered meeting intelligence, intelligent hardware systems, and next generation AI models capable of generating low level binary and machine executable code directly. We are also conducting independent research in identity analysis and recognition systems to build advanced AI technologies for real world applications.


                    </motion.p>
                </motion.div>

                </div>
            </motion.div>
            </section>

              <section  className=" pb-16 md:pt-12 md:pb-24 relative">
                <div className="absolute inset-0 bg-gradient-to-b from-white via-gray-50/20 to-white" />
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
               

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={staggerContainer}
                    className="grid lg:grid-cols-2 gap-12 items-center"
                >
                    <motion.div variants={fadeInUp} className="px-4 sm:px-0">
                  <h3 className="text-2xl md:text-3xl  mb-3 text-gray-900">
                        Priority Research
                    </h3>
                    <h3 className="text-2xl md:text-3xl  mb-3 text-gray-900">
                        AI powered meeting intelligence
                    </h3>
                    <p className="text-gray-600 mb-4 leading-relaxed">
                        We are building multimodal transformer architectures that process text, audio, and video data from real time meetings powered by our SFUdo media servers. Our research focuses on creating AI systems that can listen, observe, read, and understand live conversations to generate structured insights, meeting analysis, topic understanding, and intelligent summaries from real world communication data.

                    </p>

                    
                    </motion.div>

                    <motion.div
                    variants={fadeInUp}
                    whileHover={{ scale: 1.02 }}
                    className="flex justify-center"
                    >
                    <div className="relative">
                        <div className="absolute inset-0 bg-gradient-to-br from-gray-100/30 to-white/20 backdrop-blur-sm rounded-3xl blur-xl" />
                        <img
                        src={resrchimg}
                        alt="SMH Tech Mobile Application"
                        className="relative w-[240px] sm:w-[280px] lg:w-[320px] h-auto object-contain drop-shadow-2xl"
                        />
                    </div>
                    </motion.div>
                </motion.div>
                </div>
            </section>
         
        </section>
      )}


       {isSMHPage && (
        <section id="smhtechsection">
         

          <section id="projects" className="mt-20 pb-16 md:mt-0 md:pt-12 md:pb-24 relative">
            <div className="absolute inset-0 bg-gradient-to-b  via-gray-50/20 to-white" />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
            

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={staggerContainer}
                className="grid lg:grid-cols-2 gap-12 items-center"
              >
                <motion.div variants={fadeInUp} className="px-4 sm:px-0">
                  <motion.img
                    whileHover={{ scale: 1.05 }}
                    src={smhLogo}
                    alt="SMH Tech Logo"
                    className="h-12 mb-4"
                  />
                  <h3 className="text-2xl md:text-3xl  mb-3 text-gray-900">
                    SMH Tech
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    A complete digital learning ecosystem designed for students,
                    educators, and institutions. The platform supports video
                    lectures, secure authentication, payments, progress
                    tracking, live meeting sessions, and mobile-first learning
                    through Android applications.
                  </p>

                  {/* <div className="flex flex-wrap gap-2 mb-6">
                                        {[
                                        "E-Learning",
                                        "Android App",
                                        "Web Platform",
                                        "Cloud Backend",
                                        "Secure Streaming",
                                        ].map((tag) => (
                                        <span
                                            key={tag}
                                            className="px-3 py-1 text-xs font-medium bg-gradient-to-r from-gray-100/80 to-gray-50/80 backdrop-blur-sm text-gray-700 rounded-full border border-gray-200/50"
                                        >
                                            {tag}
                                        </span>
                                        ))}
                                    </div> */}
                  <div className="flex flex-col sm:flex-row items-center gap-3">
                    <motion.a
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      href="https://play.google.com/store/apps/details?id=com.vigyanixtech.smhtech&hl=en_IN"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-gray-900 to-black text-white rounded-lg hover:from-gray-800 hover:to-black transition-all duration-300 shadow-lg hover:shadow-xl"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className="w-5 h-5"
                        fill="currentColor"
                      >
                        <path d="M325.3 234.3L104.6 13.6c-5.5-5.5-13.6-6.9-20.4-3.6L267.5 256 84.2 502c6.8 3.3 14.9 1.9 20.4-3.6l220.7-220.7c7.6-7.6 7.6-19.8 0-27.4z" />
                      </svg>

                      <span className="text-sm font-semibold">
                        Download on Play Store
                      </span>
                    </motion.a>

                    {/* <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() => scrollToSection("smh-details")}
                      className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-semibold text-gray-900 border border-gray-900 rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300"
                    >
                      Read More
                    </motion.button> */}
                  </div>
                </motion.div>

                <motion.div
                  variants={fadeInUp}
                  whileHover={{ scale: 1.02 }}
                  className="flex justify-center"
                >
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-br from-gray-100/30 to-white/20 backdrop-blur-sm rounded-3xl blur-xl" />
                    <img
                      src={smhApp}
                      alt="SMH Tech Mobile Application"
                      className="relative w-[240px] sm:w-[280px] lg:w-[320px] h-auto object-contain drop-shadow-2xl"
                    />
                  </div>
                </motion.div>
              </motion.div>
            </div>
          </section>
        </section>
      )}
       {isSFudoPage && (
        <section id="sfudosection">
         

          <section id="projects" className="mt-20 pb-16 md:mt-15 md:pt-12 md:pb-24 relative">
            <div className="absolute inset-0 bg-gradient-to-b  via-gray-50/20 to-white" />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
            

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={staggerContainer}
                className="grid lg:grid-cols-2 gap-12 items-center"
              >
                <motion.div variants={fadeInUp} className="px-4 sm:px-0">
                  <motion.img
                    whileHover={{ scale: 1.05 }}
                    src={sfudoLogo}
                    alt="SMH Tech Logo"
                    className="h-12 mb-4"
                  />
                  <h3 className="text-2xl md:text-3xl  mb-3 text-gray-900">
                    SFUdo
                  </h3>
                 <div className="text-gray-600 mb-4 space-y-4 sm:space-y-5 text-sm sm:text-base leading-relaxed sm:leading-8">
            <p>
                Live streaming and real-time communication have become essential in
                education, collaboration, and remote interaction. Many educational
                institutes, private coaching centers, and training organizations depend on
                online live classes where students can attend lectures, interact with
                teachers, ask questions, and learn from anywhere.
            </p>

            <p>
                However, existing platforms such as Zoom Communications and Google often
                come with meeting time limitations, cloud dependency, storage restrictions,
                and recurring subscription costs. Solutions like Agora can become expensive
                at scale, especially for small educational institutes. Open-source media
                servers such as mediasoup and Kurento provide infrastructure, but they still
                require complex deployment and limit deep-level control and AI-based
                processing.
            </p>

            <p>
                To solve these challenges, we built <strong>SFUdo</strong>  a self-hosted
                SFU based real time media server designed for complete ownership and
                control. With just a public IP address, institutes can deploy SFUdo directly
                on their own systems and conduct live classes, meetings, and streaming
                sessions without relying on expensive third-party cloud platforms.
            </p>

            <p>
                SFUdo enables organizations to manage live sessions, recordings, media
                routing, and real time communication from their own infrastructure while
                maintaining full control over data, scalability, and AI driven media
                processing. It is specifically designed for e-learning platforms,
                educational institutes, and real time applications that require
                affordability, flexibility, and complete system-level control.
            </p>
</div>
   <div className="flex flex-col sm:flex-row items-center gap-3">
                   

                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() => scrollToSection("smh-details")}
                      className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-semibold text-gray-900 border border-gray-900 rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300"
                    >
                      Coming soon
                    </motion.button>
                  </div>

               
                  
                </motion.div>

                <motion.div
                  variants={fadeInUp}
                  whileHover={{ scale: 1.02 }}
                  className="flex justify-center"
                >
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-br from-gray-100/30 to-white/20 backdrop-blur-sm rounded-3xl blur-xl" />
                        <img
                        src={sfudoApp}
                        alt="SMH Tech Mobile Application"
                        className="relative w-[300px] sm:w-[360px] md:w-[430px] lg:w-[500px] xl:w-[560px] 2xl:w-[620px] h-auto object-contain drop-shadow-2xl"
                        />
                  </div>
                </motion.div>
                
              </motion.div>
            </div>
          </section>
        </section>
      )}

     {isNewsPage && (
  <section id="newssection">
    <section
      id="projects"
      className="mt-20 pb-16 md:mt-20 md:pt-12 md:pb-24 relative"
    >
      <div className="absolute inset-0 bg-gradient-to-b via-gray-50/20 to-white" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={staggerContainer}
          className="space-y-8"
        >
          <motion.div variants={fadeInUp} className="px-4 sm:px-0">
            <h3 className="text-2xl md:text-3xl mb-3 text-gray-900">
              News
            </h3>
            <p className="text-gray-600 text-sm sm:text-base">
              Latest updates and announcements.
            </p>
          </motion.div>

          <div className="grid gap-6">
            {newsItems.map((news, index) => (
              <motion.article
                key={index}
                variants={fadeInUp}
                className="rounded-2xl border border-gray-200/70 bg-white/90 p-5 sm:p-6 shadow-sm hover:shadow-md transition-all duration-300"
              >
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-3">
                  <span className="text-xs sm:text-sm  text-gray-500">
                    {news.date}
                  </span>

                  <span className="w-fit rounded-full bg-gray-100 px-3 py-1 text-xs text-gray-600">
                    Announcement
                  </span>
                </div>

                <h4 className="text-xl sm:text-2xl  text-gray-900 mb-3">
                  {news.title}
                </h4>

                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                  {news.description}
                </p>
              </motion.article>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  </section>
)}
{isOpporPage && (
  <section id="oppsection">
    <section
      id="projects"
      className="mt-20 pb-16 md:mt-20 md:pt-12 md:pb-24 relative"
    >
      <div className="absolute inset-0 bg-gradient-to-b via-gray-50/20 to-white" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={staggerContainer}
          className="space-y-8"
        >
          <motion.div variants={fadeInUp} className="px-4 sm:px-0">
            <h3 className="text-2xl md:text-3xl mb-3 text-gray-900">
              Opportunities
            </h3>
            <p className="text-gray-600 text-sm sm:text-base">
              We will be launching our opportunities soon. For now, get in touch with us and stay updated.
            </p>
          </motion.div>

        </motion.div>
      </div>
    </section>
  </section>
)}
        <section id="contact" className=" pb-16 md:pt-16 md:pb-24 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-800 to-black" />
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="text-center mb-12"
          >
            <span className="pt-10 text-sm font-semibold text-gray-300 uppercase tracking-wider">
              Get In Touch
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mt-3 mb-4 text-white">
              Let's Build 
            </h2>
            {/* <p className="text-gray-300 max-w-lg mx-auto leading-relaxed">
              Ready to transform your ideas into reality? Reach out to discuss
              your next big project.
            </p> */}
          </motion.div>

          <motion.div
            variants={fadeInUp}
            className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 md:p-8 shadow-2xl relative overflow-hidden"
          >
            <div className="absolute top-0 right-0 w-48 h-48 bg-gradient-to-bl from-white/5 to-transparent rounded-full -translate-y-24 translate-x-24" />
            <form onSubmit={handleSubmit} className="space-y-5 relative z-10">
              <div className="grid md:grid-cols-2 gap-5">
                <div>
                  <label className="block text-white text-sm font-medium mb-1.5">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your name"
                    className="w-full px-4 py-2.5 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-white/30 focus:ring-2 focus:ring-white/20 transition text-sm"
                  />
                </div>
                <div>
                  <label className="block text-white text-sm font-medium mb-1.5">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your@email.com"
                    className="w-full px-4 py-2.5 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-white/30 focus:ring-2 focus:ring-white/20 transition text-sm"
                  />
                </div>
              </div>
              <div>
                <label className="block text-white text-sm font-medium mb-1.5">
                  Message
                </label>
                <textarea
                  name="message"
                  rows={3}
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about you , your project , any..."
                  className="w-full px-4 py-2.5 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-white/30 focus:ring-2 focus:ring-white/20 transition text-sm"
                />
              </div>
              <motion.button
                whileHover={!isSubmitting ? { scale: 1.02 } : {}}
                whileTap={!isSubmitting ? { scale: 0.98 } : {}}
                type="submit"
                disabled={isSubmitting}
                className={`w-full px-6 py-3 text-sm font-semibold rounded-lg transition-all duration-300 shadow-lg
    ${
      isSubmitting
        ? "bg-white/10 text-gray-300 cursor-not-allowed"
        : "text-white bg-gradient-to-r from-white/20 via-white/15 to-white/10 hover:from-white/30 hover:via-white/20 hover:to-white/15"
    }`}
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center gap-2">
                    <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
                    Sending...
                  </span>
                ) : (
                  "Send Message"
                )}
              </motion.button>
            </form>
          </motion.div>
        </div>
        {toast.show && (
          <div className="fixed bottom-6 right-6 z-[9999]">
            <div
              className={`px-6 py-4 rounded-xl shadow-2xl text-sm font-medium max-w-sm
        ${
          toast.type === "error"
            ? "bg-red-600 text-white"
            : "bg-green-600 text-white"
        }`}
            >
              {toast.message}
            </div>
          </div>
        )}
      </section>
      {/* ================= FOOTER ================= */}
      <footer className="bg-black text-gray-400 py-8 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/30 to-transparent" />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="flex flex-col md:flex-row justify-between items-center mb-6">
            <div className="mb-4 md:mb-0 text-center md:text-left">
              <motion.img
                whileHover={{ scale: 1.05 }}
                src={wlogo}
                alt="BashDot Logo"
                className="h-10 w-auto object-contain mb-2 mx-auto md:mx-0"
              />
              <p className="text-gray-500 text-xs mb-2 ml-3">
                Building the future with innovative technology solutions
              </p>

              {/* Company Contact Details */}
              <div className="mt-3 space-y-1 ml-3">
                <div className="flex items-center justify-center md:justify-start gap-2 text-xs text-gray-400">
                  <FiMail className="w-3 h-3" />
                  <span>info@bashdot.com</span>
                </div>
                <div className="flex items-center justify-center md:justify-start gap-2 text-xs text-gray-400">
                  <FiPhone className="w-3 h-3" />
                  <span>+91 9579695567 | +91 9067788378</span>
                </div>
              </div>
            </div>

            {/* <div className="flex space-x-4">
              {["Twitter", "LinkedIn", "GitHub", "Instagram"].map(
                (platform) => (
                  <motion.a
                    key={platform}
                    whileHover={{ y: -2 }}
                    href="#"
                    className="text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {platform}
                  </motion.a>
                )
              )}
            </div> */}
          </div>

          <div className="pt-4 border-t border-gray-800 text-center text-xs text-gray-500">
            © {new Date().getFullYear()} BashDot. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;
